// extracted by mini-css-extract-plugin
export default {"feedbackPage":"Xaudo_N8","header":"UKeNLNVm","headerActions":"NI2ubC8q","cardsContainer":"ZA784nbC"};